import * as tf from "@tensorflow/tfjs";
import { MOVES } from "@/constants";

export class DefaultConverter {
  convert(state) {
    let inputTensor = tf.tensor(state);
    return inputTensor
      .slice([0, 1], [inputTensor.shape[0], inputTensor.shape[1] - 2])
      .expandDims(0);
  }
}

export class ConverterV1 {
  convert(state) {
    let new_state = Array(9).fill(Array(11).fill(Array(9).fill(0)));
    for (let x = 0; x < 9; x++) {
      for (let y = 0; y < 11; y++) {
        if (state[x][y][0] & MOVES.LEFT) {
          new_state[x][y][0] = 1;
        }
        if (state[x][y][0] & MOVES.LEFT_TOP) {
          new_state[x][y][1] = 1;
        }
        if (state[x][y][0] & MOVES.TOP) {
          new_state[x][y][2] = 1;
        }
        if (state[x][y][0] & MOVES.RIGHT_TOP) {
          new_state[x][y][3] = 1;
        }
        if (state[x][y][0] & MOVES.RIGHT) {
          new_state[x][y][4] = 1;
        }
        if (state[x][y][0] & MOVES.RIGHT_BOTTOM) {
          new_state[x][y][5] = 1;
        }
        if (state[x][y][0] & MOVES.BOTTOM) {
          new_state[x][y][6] = 1;
        }
        if (state[x][y][0] & MOVES.LEFT_BOTTOM) {
          new_state[x][y][7] = 1;
        }
        if (state[x][y][1]) {
          new_state[x][y][8] = 1;
        }
      }
    }
    return tf.tensor(new_state).expandDims(0);
  }
}
